const updates = [
  { title: '《流浪地球3》高清蓝光版现已上线', time: '2小时前', tag: '新片上线', tagColor: 'accent' },
  { title: '《封神第二部：战火西岐》独家登陆', time: '5小时前', tag: '独家', tagColor: 'primary' },
  { title: '《哪吒之魔童闹海》4K修复版更新完毕', time: '8小时前', tag: '修复版', tagColor: 'secondary' },
  { title: '暑期档专题页面上线，百部佳片一网打尽', time: '昨天', tag: '专题', tagColor: 'accent' },
  { title: '《奥本海默》导演剪辑版蓝光片源发布', time: '昨天', tag: '蓝光', tagColor: 'primary' },
  { title: '豆瓣年度TOP250电影合集全面更新', time: '前天', tag: '合集', tagColor: 'secondary' },
  { title: '经典港片修复计划第三期完成上架', time: '3天前', tag: '经典', tagColor: 'accent' },
  { title: '《沙丘3》先导预告解析专题火热上线', time: '4天前', tag: '预告', tagColor: 'primary' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          片库实时更新，精彩内容不错过
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, i) => (
              <div key={i} className="relative mb-7 last:mb-0">
                <div className={`absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full border-2 border-background-50 ${
                  item.tagColor === 'accent' ? 'bg-accent-500' : item.tagColor === 'primary' ? 'bg-primary-500' : 'bg-secondary-500'
                }`}></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap w-fit ${
                    item.tagColor === 'accent' ? 'bg-accent-100 text-accent-700' :
                    item.tagColor === 'primary' ? 'bg-primary-100 text-primary-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                  <p className="text-sm text-foreground-800 font-medium flex-1">{item.title}</p>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}